import { useState, useEffect } from 'react';
import '../../../styles/Auth/purchase.css';
const PurchaseHeader = ({onApplyFilters}) => {
    const [filters, setFilters] = useState({
        startDate: "",
        endDate: "",
    });
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFilters((prev) => ({ ...prev, [id]: value }));
    };
    const handleClear = () => {
        const empty = {
            startDate: "",
            endDate: "",
        };
        setFilters(empty);

        // Remove any persisted filters
        sessionStorage.removeItem("headerFilters");

        if (typeof onApplyFilters === "function") {
            onApplyFilters({});
        }
    };
    const handleApply = () => {
        sessionStorage.setItem("headerFilters", JSON.stringify(filters));
        if (typeof onApplyFilters === "function") {
            onApplyFilters(filters);
        }
    };
    return (
        <>
            <div className='Date'>
                <div className='start-Date'>
                    <label>Start Date</label>
                    <input
                        type="date"
                        id="startDate"
                        className="purchase-date-input"
                        value={filters.startDate || ""}
                        onChange={handleChange}
                    />
                </div>
                <div className='end-Date'>
                    <label>End Date</label>
                    <input
                        type="date"
                        id="endDate"
                        className="purchase-date-input"
                        value={filters.endDate || ""}
                        onChange={handleChange}
                    />
                </div>
                <div className="Buttons">
                    <div className="clear-button">
                        <button className="clear" onClick={handleClear}
                            type='button'
                            style={
                                {
                                    cursor: "pointer"
                                }
                            }
                        >
                            Clear
                        </button>
                    </div>
                    <div className="apply-button">
                        <button
                            className="Apply"
                            type='button'
                            style={{
                                border: "0px",
                                borderRadius: "10px",
                                padding: "10px",
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "white",
                                background: "#8D2629",
                                cursor: "pointer"
                            }}
                            onClick={handleApply}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PurchaseHeader;